import React from 'react';

import { SobrePage, SobreSection } from 'src/styles/styledComponents';

import logo from '../assets/images/logoASMUBIP5.png';
import Typography from '@mui/material/Typography';

export default function Sobre() {
  return (
    <SobrePage>
      <SobreSection>
        <img src={logo} />
      </SobreSection>
      <SobreSection>
        <Typography>
          A ASMUBIP, Associação Regional das Mulheres Trabalhadoras Rurais do Bico do Papagaio, atua
          desde 1992 no extremo norte do Tocantins, promovendo a organização, a formação e o
          fortalecimento das mulheres que vivem da agricultura e do extrativismo do babaçu,
          especialmente as quebradeiras de coco.
        </Typography>
      </SobreSection>
      <SobreSection>
        <Typography>
          Nascida da luta coletiva por direitos, justiça e valorização dos modos de vida
          tradicionais, a ASMUBIP reúne hoje cerca de 500 sócias, organizadas em 46 núcleos de base,
          presentes em 12 municípios da região. Sua atuação tem como foco principal a defesa dos
          babaçuais, o fortalecimento da agroecologia, o desenvolvimento sustentável das comunidades
          e a luta pelos direitos das mulheres.
        </Typography>
      </SobreSection>
      <SobreSection>
        <Typography>
          A Associação promove formações em temas como gênero, saúde, direitos das mulheres e
          combate à violência, além de incentivar a autonomia política e econômica das
          trabalhadoras. Também apoia ações voltadas à estruturação da cadeia do babaçu, desde o
          beneficiamento até a comercialização de seus produtos e subprodutos.
        </Typography>
      </SobreSection>
      <SobreSection>
        <Typography>
          Este aplicativo foi desenvolvido em parceria com a APA-TO com o patrocínio do SERPRO e do
          Governo Federal como parte do compromisso com a valorização do extrativismo sustentável, a
          inclusão digital e o fortalecimento das quebradeiras de coco babaçu.
        </Typography>
      </SobreSection>
    </SobrePage>
  );
}
